import deleteLayers from 'common/src/modules/creativeTemplates/store/creativeTemplatePage/formatMovies/actions/deleteLayers';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {AdBuilderAgentToolName} from '../adBuilderAgent.enums';

const inputSchema = z.object({
  layerIds: z.array(z.string()).describe('Array of layer IDs to delete'),
});

function deleteLayersTool(store: CLStore) {
  return tool({
    name: AdBuilderAgentToolName.DeleteLayers,
    displayName: 'Deleting layer/s',
    description: 'Delete one or more layers from the active composition by their IDs',
    inputSchema,
    execute: async ({input: {layerIds}}: ToolExecuteParams<typeof inputSchema>) => {
      try {
        // Delete the layers
        await store.dispatch(deleteLayers({layerIds}));

        return {
          content: `Deleted ${layerIds.length} layer(s)`,
        };
      } catch (error) {
        return {
          content: `Failed to delete layers: ${error instanceof Error ? error.message : 'Unknown error'}`,
          error: error instanceof Error ? error.message : 'Failed to delete layers',
        };
      }
    },
  });
}

export default deleteLayersTool;
